import {queries} from '@/shared/integrations/zero'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'

export function useGetSupportiveMedicationDrug(drugId: string | undefined) {
  const [drug, query] = useQuery(queries.drugCatalog.getSupportiveMedicationById(drugId || ''))
  return [drug as unknown as DrugCatalogItem, query] as const
}
